module.exports = function isObjectName (objectName) {
  return !!(objectName && objectName.match(/xml$/gmi))
}
